import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FullChartViewContextType {
  isFullChartView: boolean;
  toggleFullChartView: () => void;
  setFullChartView: (value: boolean) => void;
}

const FullChartViewContext = createContext<FullChartViewContextType | undefined>(undefined);

export const useFullChartView = () => {
  const context = useContext(FullChartViewContext);
  if (context === undefined) {
    throw new Error('useFullChartView must be used within a FullChartViewProvider');
  }
  return context;
};

interface FullChartViewProviderProps {
  children: ReactNode;
}

export const FullChartViewProvider: React.FC<FullChartViewProviderProps> = ({ children }) => {
  const [isFullChartView, setIsFullChartView] = useState(false);

  const toggleFullChartView = () => {
    setIsFullChartView(prev => !prev);
  };

  const setFullChartView = (value: boolean) => {
    setIsFullChartView(value);
  };

  return (
    <FullChartViewContext.Provider value={{ isFullChartView, toggleFullChartView, setFullChartView }}>
      {children}
    </FullChartViewContext.Provider>
  );
};
